import { useState } from 'react';
import { Column, Row } from 'further-ui/components/Layout';
import { styled, Typography, TextField } from '@mui/material';
import Button from 'components/Button';

const Form = styled(Column)(({ theme }) => ({
  padding: theme.spacing(0, 0, 0, theme.spacingSizes.sm),
}));

type Props = {
  onClose: () => void;
  onSubmitForm: (message: string) => void;
  isSubmitting: boolean;
};

const RequestMoreInformationForm: React.FC<Props> = ({
  onSubmitForm,
  onClose,
  isSubmitting,
}) => {
  const [message, setMessage] = useState('');

  return (
    <Form spacing="sm">
      <Row justify="space-between" fullWidth spacing="sm">
        <Column>
          <Typography variant="h6">Request additional information</Typography>
          <Typography variant="body2" color="grey.600">
            What message do you want to accompany this request?
          </Typography>
        </Column>
        <Column>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            onClick={onClose}
          >
            Cancel
          </Button>
        </Column>
      </Row>
      <Row spacing="sm" centered>
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          placeholder="Enter text"
          onBlur={(event) => {
            setMessage(event.target.value);
          }}
          multiline
          rows={2}
          value={message}
          onChange={(event) => {
            setMessage(event.target.value);
          }}
        />
        <Button
          variant="contained"
          color="primary"
          size="large"
          loading={isSubmitting}
          disabled={!message.trim()}
          onClick={() => {
            onSubmitForm(message.trim());
          }}
        >
          Send
        </Button>
      </Row>
    </Form>
  );
};

export default RequestMoreInformationForm;
